import React, { useEffect } from "react";
import { X, ArrowRight } from "lucide-react";

export const Modal = ({ open, onClose, title, eyebrow, children, ctaLabel = "Solicitar información", ctaHref = "/#contacto" }) => {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-3 sm:p-6"
      data-testid="modal"
      role="dialog"
      aria-modal="true"
    >
      <div className="absolute inset-0 bg-black/75 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-gradient-to-br from-[#0F1E36] to-[#0A1628] border border-white/10 rounded-3xl max-w-2xl w-full max-h-[88vh] overflow-y-auto shadow-2xl shadow-[#0066FF]/20">
        <button
          onClick={onClose}
          data-testid="modal-close"
          aria-label="Cerrar"
          className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center text-slate-300 hover:text-white transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
        <div className="p-6 sm:p-8 md:p-10">
          {eyebrow && (
            <div className="text-xs uppercase tracking-[0.22em] text-[#FF6B00] font-semibold mb-3">
              {eyebrow}
            </div>
          )}
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-6 pr-10 leading-tight" style={{ fontFamily: "Poppins" }}>
            {title}
          </h3>
          <div className="text-slate-300 leading-relaxed space-y-4 text-sm md:text-base [&_a]:text-[#3B8AFF] [&_a]:underline [&_a:hover]:text-white [&_strong]:text-white [&_h4]:text-white [&_h4]:font-semibold [&_h4]:text-base [&_h4]:mt-5 [&_h4]:mb-2 [&_ul]:space-y-1.5 [&_ul]:list-none [&_ul]:pl-0 [&_li]:relative [&_li]:pl-5 [&_li]:before:content-['→'] [&_li]:before:absolute [&_li]:before:left-0 [&_li]:before:text-[#0066FF]">
            {children}
          </div>
          <a
            href={ctaHref}
            onClick={onClose}
            data-testid="modal-cta"
            className="mt-8 inline-flex items-center gap-2 bg-[#0066FF] hover:bg-[#0052CC] text-white font-medium px-6 py-3 rounded-xl transition-all shadow-lg shadow-[#0066FF]/30 hover:-translate-y-0.5"
          >
            {ctaLabel}
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </div>
  );
};

// Convenience: external link helper used inside modal bodies
export const Ext = ({ href, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>
);

export default Modal;
